import { render, staticRenderFns } from "./Que4.vue?vue&type=template&id=5cc6715b&scoped=true&"
import script from "./Que4.vue?vue&type=script&lang=js&"
export * from "./Que4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc6715b",
  null
  
)

export default component.exports